"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearbyCommuteDurationUnit = void 0;
var NearbyCommuteDurationUnit;
(function (NearbyCommuteDurationUnit) {
    NearbyCommuteDurationUnit[NearbyCommuteDurationUnit["MIN"] = 0] = "MIN";
    NearbyCommuteDurationUnit[NearbyCommuteDurationUnit["HOUR"] = 1] = "HOUR";
})(NearbyCommuteDurationUnit || (NearbyCommuteDurationUnit = {}));
exports.NearbyCommuteDurationUnit = NearbyCommuteDurationUnit;
